import React, { useState, useEffect } from 'react';
import AutoComplete from '../Common/AutoComplete';
import PlayerSearch from '../Common/PlayerSearch';
import PlayerBio from '../Common/PlayerBio';
import { columnManager } from '../Common/ColumnManager';
import PlayerStats from './PlayerStats';
import GameLogs from './GameLogs';
import PlayerSplits from './PlayerSplits';
import Contracts from './Contracts';
import Transactions from './Transactions';
import { GetPlayers } from '../../Services/ApiSvc';
import { Navbar, Nav } from 'react-bootstrap';
import PlayerAwards from './PlayerAwards';

function PlayerPage() {
    const [allPlayers, setAllPlayers] = useState([]);
    const [groups, setGroups] = useState([]);
    const [playerId, setPlayerId] = useState(0);
    const [player, setPlayer] = useState({})
    const [tabName, setTabName] = useState('transactions');

    useEffect(() => {
        (async function Initialize() {
            let allPlayersFromAPI = await GetPlayers();
            let rankReportGroups = await columnManager.getAllGroupsBySection('PlayerPage');

            setAllPlayers(allPlayersFromAPI);
            setGroups(rankReportGroups);
        })()
    }, []);

    useEffect(() => {
        if (playerId > 0) {
            let player = allPlayers.find((p) => p.id === playerId)
            setPlayer(player)
            if (tabName === 'reliefPitcher' && player.posFlag !== 'P')
                setTabName('transactions');
        }
    }, [playerId]);

    return (
        <div className='body player-page'>
            <div className='row'>
                <div style={{ margin: '0px 0px 0px auto' }}>
                    <PlayerSearch
                        key={0}
                        players={allPlayers}
                        label={'Player Search'}
                        onSelect={(playerId, platformSeason, posFlag) => setPlayerId(playerId)}
                    />
                </div>
            </div>
            <br />
            {
                playerId > 0 &&
                <div className='pdfSection'>
                    <PlayerBio playerId={playerId} />
                    <div className='pdfChunk pdfIgnore'>
                        <br />
                        <Navbar bg='light' variant='light' className='playerNav'>
                            <Nav>
                                <Nav.Link className={tabName === 'stats' ? 'nav-selected' : null} href='#stats' onClick={() => setTabName('stats')}>
                                    {
                                        tabName === 'stats' &&
                                        <span style={{ transform: 'translateX(32px) rotate(135deg)' }}></span>
                                    }
                                    Player Stats
                                </Nav.Link>
                                <Nav.Link hidden='true' className={tabName === 'games' ? 'nav-selected' : null} href='#games' onClick={() => setTabName('games')}>
                                    {
                                        tabName === 'games' &&
                                        <span style={{ transform: 'translateX(34px) rotate(135deg)' }}></span>
                                    }
                                    Game Logs
                                </Nav.Link>
                                <Nav.Link hidden='true' className={tabName === 'splits' ? 'nav-selected' : null} href='#splits' onClick={() => setTabName('splits')}>
                                    {
                                        tabName === 'splits' &&
                                        <span style={{ transform: 'translateX(12px) rotate(135deg)' }}></span>
                                    }
                                    Splits
                                </Nav.Link>
                                <Nav.Link className={tabName === 'awards' ? 'nav-selected' : null} href='#awards' onClick={() => setTabName('awards')}>
                                    {
                                        tabName === 'awards' &&
                                        <span style={{ transform: 'translateX(12px) rotate(135deg)' }}></span>
                                    }
                                    Awards
                                </Nav.Link>
                                <Nav.Link className={tabName === 'contracts' ? 'nav-selected' : null} href='#contracts' onClick={() => setTabName('contracts')}>
                                    {
                                        tabName === 'contracts' &&
                                        <span style={{ transform: 'translateX(27px) rotate(135deg)' }}></span>
                                    }
                                    Contracts
                                </Nav.Link>
                                <Nav.Link className={tabName === 'transactions' ? 'nav-selected' : null} href='#transactions' onClick={() => setTabName('transactions')}>
                                    {
                                        tabName === 'transactions' &&
                                        <span style={{ transform: 'translateX(60px) rotate(135deg)' }}></span>
                                    }
                                    Transaction/Roster
                                </Nav.Link>
                            </Nav>
                        </Navbar>
                        <br />
                    </div>
                    {
                        tabName === 'stats' &&
                        <PlayerStats player={player} />
                    }
                    {
                        tabName === 'games' &&
                        <GameLogs />
                    }
                    {
                        tabName === 'splits' &&
                        <PlayerSplits />
                    }
                    {
                        tabName === 'awards' &&
                        <PlayerAwards
                            groups={groups}
                            player={player}
                        />
                    }
                    {
                        tabName === 'contracts' &&
                        <Contracts
                            playerId={playerId}
                            groups={groups}
                        />
                    }
                    {
                        tabName === 'transactions' &&
                        <Transactions
                            playerId={playerId}
                            groups={groups}
                        />
                    }
                    <br />
                </div>
            }
        </div>
    )
}

export default PlayerPage;